const MATTERPORT_SAMPLES = [
  "https://my.matterport.com/show/?m=3J4Ld5QzP2t&brand=0",
  "https://my.matterport.com/show/?m=GA9Ntv4kQzS&brand=0",
  "https://my.matterport.com/show/?m=DDtZ2TCa4pd&brand=0",
];

export default MATTERPORT_SAMPLES;
